import _ from 'lodash';
import Vue from 'vue';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultMember = {
  is_approved: true,
};

export default {
  getters: {
    [getters.GET_MEMBER]: state => state.member,
    [getters.GET_MEMBERS]: state => state.members,
  },
  actions: {
    async [actions.DO_CREATE_MEMBER]({ commit }, payload) {
      const { data } = await HTTP.post('/members', payload);
      commit(mutations.SET_MEMBER, data.data.members[0]);
      return data;
    },
    async [actions.DO_GET_MEMBER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/members/${id}`, { params });
      commit(mutations.SET_MEMBER, data.data.members[0]);
      return data;
    },
    async [actions.DO_SEARCH_MEMBERS]({ commit }, payload) {
      const { data } = await SEARCH.post('/doxa_members/member/_search', payload);
      const members = data.hits.hits.map(h => h._source);
      commit(mutations.SET_MEMBERS, members);
      return data;
    },
    async [actions.DO_UPDATE_MEMBER]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/members/${id}`, params);
      commit(mutations.SET_MEMBER, data.data.members[0]);
      return data;
    },
  },
  mutations: {
    [mutations.SET_MEMBER](state, member) {
      state.member = member;
    },
    [mutations.SET_MEMBER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.member;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_MEMBERS](state, members) {
      state.members = members;
    },
    [mutations.UNSET_MEMBER](state) {
      state.member = _.cloneDeep(defaultMember);
    },
  },
  state: {
    member: _.cloneDeep(defaultMember),
    members: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/member.js